import { connect } from "react-redux";

import { reducer, mapStateToProps, mapDispatchToProps } from "./Payment.state";
import Payment from "./Payment";

export default connect(mapStateToProps, mapDispatchToProps)(Payment);

export { reducer, mapStateToProps, mapDispatchToProps };
